import { types } from './device.action'

const initialState = {
  isMobileView: false
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
      case types.APP_IS_MOBILE:
        return {
            ...state,
            isMobileView: action.payload
        }
      default:
        return state
    }
  }
  